import * as ActionTypes from '../constants/ActionTypes';

const initialState = {
	ticket: null,
	machines: [],
	loadingTicketDetail: false,
	loadingMachines: false,
	loadingSubmit: false
};

export default function reserveMachinePageReducer(state = initialState, action) {
	switch (action.type) {
		case ActionTypes.GET_RESERVE_TICKET_DETAIL_REQUEST:
		case ActionTypes.GET_RESERVE_TICKET_DETAIL_ERROR:
		case ActionTypes.GET_RESERVE_TICKET_DETAIL_SUCCESS:
		case ActionTypes.GET_RESERVE_MACHINE_PAGE_REQUEST:
		case ActionTypes.GET_RESERVE_MACHINE_PAGE_ERROR:
		case ActionTypes.GET_RESERVE_MACHINE_PAGE_SUCCESS:
		case ActionTypes.SUBMIT_RESERVE_MACHINE_PAGE_REQUEST:
		case ActionTypes.SUBMIT_RESERVE_MACHINE_PAGE_ERROR:
		case ActionTypes.SUBMIT_RESERVE_MACHINE_PAGE_SUCCESS:
			return {
				...state,
				...action.payload
			};
		case ActionTypes.RESET_RESERVE_MACHINE_PAGE_META:
			return {
				...state,
				meta: null
			};
		case ActionTypes.RESET_RESERVE_MACHINE_PAGE:
			return {
				...initialState
			};
		default:
			return state;
	}
}
